import { api, ApiError, type Video } from './api';

/** Save a discovered video to the signed-in user's library; optionally mark it Watch later. */
export async function saveVideo(v: Video, opts: { watchLater?: boolean } = {}): Promise<'saved' | 'duplicate' | 'restored'> {
  let id: string;
  let outcome: 'saved' | 'duplicate' | 'restored' = 'saved';
  try {
    const r = await api<{ id: string; restored?: boolean }>('/v1/library', {
      method: 'POST',
      body: {
        kind: 'youtube', url: `https://www.youtube.com/watch?v=${v.id}`, title: v.title,
        meta: { videoId: v.id, channelTitle: v.channelTitle, thumbnail: v.thumbnail && /^https:\/\//.test(v.thumbnail) ? v.thumbnail : null, durationSec: v.durationSec, definition: v.definition, categoryId: v.categoryId },
      },
    });
    id = r.id;
    if (r.restored) outcome = 'restored';
  } catch (e) {
    if (!(e instanceof ApiError) || e.status !== 409 || typeof e.data.id !== 'string') throw e;
    id = e.data.id;
    outcome = 'duplicate';
  }
  if (opts.watchLater) await api(`/v1/library/${id}`, { method: 'PATCH', body: { watchLater: true } });
  return outcome;
}
